import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: 'client-notifications',
    loadComponent: () => import('./client-notifications/client-notifications.page').then(m => m.ClientNotificationsPage),
  },
  {
    path: 'splash-screen',
    loadComponent: () => import('./splash-screen/splash-screen.page').then(m => m.SplashScreenPage),
  },
  {
    path: '',
    redirectTo: 'splash-screen',
    pathMatch: 'full',
  },
  {
    path: 'VisitPage',
    redirectTo: 'visit',
    pathMatch: 'full',
  },
  {
    path: 'PlacesPage',
    redirectTo: 'places',
    pathMatch: 'full',
  },
  {
    path: 'signup',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'places',
    loadComponent: () => import('./places/places.page').then(m => m.PlacesPage),
  },
  {
    path: 'visit',
    loadComponent: () => import('./visit/visit.page').then(m => m.VisitPage),
  },
  {
    path: 'analyze',
    loadComponent: () => import('./analyze/analyze.page').then(m => m.AnalyzePage),
  },
  {
    path: 'analyze-list',
    loadComponent: () => import('@shared/pages/analyze-list/analyze-list.page').then(m => m.AnalyzeListPage),
  },
  {
    path: 'synchronization',
    loadComponent: () => import('@shared/pages/synchronization/synchronization.page').then(m => m.SynchronizationPage),
  },
  {
    path: 'aplication',
    loadComponent: () => import('@shared/pages/aplication/aplication.page').then(m => m.AplicationPage),
  },
  {
    path: 'camera',
    loadComponent: () => import('@shared/pages/camera/camera.page').then(m => m.CameraPage),
  },
  {
    path: 'check-list',
    loadComponent: () => import('./check-list/check-list.page').then(m => m.CheckListPage),
  },
  {
    path: 'local-creation',
    loadComponent: () => import('@shared/pages/local-creation/local-creation.page').then(m => m.LocalCreationPage),
  },
  {
    path: 'map',
    loadComponent: () => import('@shared/pages/map/map.page').then(m => m.MapPage),
  },
  {
    path: 'photo',
    loadComponent: () => import('@shared/pages/photo/photo.page').then(m => m.PhotoPage),
  },
  {
    path: 'necessary-products-confirmation',
    loadComponent: () => import('@shared/pages/necessary-products-confirmation/necessary-products-confirmation.page')
      .then(m => m.NecessaryProductsConfirmationPage),
  },
  {
    path: 'pool-registration',
    loadComponent: () => import('@shared/pages/pool-registration/pool-registration.page').then(m => m.PoolRegistrationPage),
  },
  {
    path: 'special-treatment-selection',
    loadComponent: () => import('@shared/pages/special-treatment-selection/special-treatment-selection.page')
      .then(m => m.SpecialTreatmentSelectionPage),
  },
  {
    path: 'special-treatment-initial-information',
    loadComponent: () => import('@shared/pages/special-treatment-initial-information/special-treatment-initial-information.page')
      .then(m => m.SpecialTreatmentInitialInformationPage),
  },
  {
    path: 'special-treatment-questions',
    loadComponent: () => import('@shared/pages/special-treatment-questions/special-treatment-questions.page')
      .then(m => m.SpecialTreatmentQuestionsPage),
  },
  {
    path: 'products-settings',
    loadComponent: () => import('@shared/pages/products-settings/products-settings.page').then(m => m.ProductsSettingsPage),
  },
  {
    path: 'questionnaire',
    loadComponent: () => import('./questionnaire/questionnaire.page').then(m => m.QuestionnairePage),
  },
  {
    path: 'report-problems',
    loadComponent: () => import('./report-problems/report-problems.page').then(m => m.ReportProblemsPage),
  },
  {
    path: 'transferences',
    loadComponent: () => import('./transferences/transferences.page').then(m => m.TransferencesPage),
  },
  {
    path: 'clock-and-visit-operation',
    loadComponent: () => import('./clock-and-visit-operation/clock-and-visit-operation.page').then(m => m.ClockAndVisitOperationPage),
  },
  {
    path: 'chlorine-real-price',
    loadComponent: () => import('@shared/pages/chlorine-real-price/chlorine-real-price.page').then(m => m.ChlorineRealPricePage),
  },
  {
    path: 'suport-chat',
    loadComponent: () => import('@shared/pages/suport-chat/suport-chat.page').then(m => m.SuportChatPage),
  },
  {
    path: 'support-tickets',
    loadComponent: () => import('@shared/pages/support-tickets/support-tickets.page').then(m => m.SupportTicketsPage),
  },
  {
    path: 'support-ticket/:supportTicketId',
    loadComponent: () => import('@shared/pages/support-ticket/support-ticket.page').then(m => m.SupportTicketPage),
  },
  {
    path: 'selfie-photo-verification',
    loadComponent: () => import('./selfie-photo-verification/selfie-photo-verification.page').then(m => m.SelfiePhotoVerificationPage),
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('@shared/pages/terms-of-use/terms-of-use.page').then(m => m.TermsOfUsePage),
  },
  {
    path: 'services-performed',
    loadComponent: () => import('./services-performed/services-performed.page').then(m => m.ServicesPerformedPage),
  },
  {
    path: 'places-admin',
    loadComponent: () => import('./places-admin/places-admin.page').then(m => m.PlacesAdminPage),
  },
  {
    path: 'users-admin',
    loadComponent: () => import('./users-admin/users-admin.page').then(m => m.UsersAdminPage),
  },
  {
    path: 'products-admin',
    loadComponent: () => import('./products-admin/products-admin.page').then(m => m.ProductsAdminPage),
  },
  {
    path: 'equipments-admin',
    loadComponent: () => import('./equipments-admin/equipments-admin.page').then(m => m.EquipmentsAdminPage),
  },
  {
    path: 'stock-movements',
    loadComponent: () => import('./stock-movements/stock-movements.page').then(m => m.StockMovementsPage),
  },
  {
    path: 'analyzes-admin',
    loadComponent: () => import('./analyzes-admin/analyzes-admin.page').then(m => m.AnalysesAdminPage),
  },
  {
    path: 'analyzes-admin/:referenceType/:referenceId',
    loadComponent: () => import('./analyzes-admin/analyzes-admin.page').then(m => m.AnalysesAdminPage),
  },
  {
    path: 'reports',
    loadComponent: () => import('./reports/reports.page').then(m => m.ReportsPage),
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notifications/notifications.page').then(m => m.NotificationsPage),
  },
  {
    path: 'monitoring',
    loadComponent: () => import('./monitoring/monitoring.page').then(m => m.MonitoringPage),
  },
  {
    path: 'product-suggestion-rules-admin',
    loadComponent: () => import('./product-suggestion-rules-admin/product-suggestion-rules-admin.page')
      .then(m => m.ProductSuggestionRulesAdminPage),
  },
  {
    path: 'protocols-admin',
    loadComponent: () => import('./protocols-admin/protocols-admin.page').then(m => m.ProtocolsAdminPage),
  },
  {
    path: 'protocol-admin-form/:protocolId',
    loadComponent: () => import('./protocol-admin-form/protocol-admin-form.page').then(m => m.ProtocolAdminFormPage),
  },
  {
    path: 'special-treatment-details-admin',
    loadComponent: () => import('./special-treatment-details-admin/special-treatment-details-admin.page')
      .then(m => m.SpecialTreatmentDetailsAdminPage),
  },
  {
    path: 'special-treatment-details-admin-form/:specialTreatmentDetailsId',
    loadComponent: () => import('./special-treatment-details-admin-form/special-treatment-details-admin-form.page')
      .then(m => m.SpecialTreatmentDetailsAdminFormPage),
  },
  {
    path: 'support-chat',
    loadComponent: () => import('./support-chat/support-chat.page').then(m => m.SupportChatPage),
  },
  {
    path: 'user-admin-form/employee/:employeeId',
    loadComponent: () => import('./user-admin-form/user-admin-form.page').then(m => m.UserAdminFormPage),
  },
  {
    path: 'user-admin-form/:userId',
    loadComponent: () => import('./user-admin-form/user-admin-form.page').then(m => m.UserAdminFormPage),
  },
  {
    path: 'local-admin-form/:localId',
    loadComponent: () => import('./local-admin-form/local-admin-form.page').then(m => m.LocalAdminFormPage),
  },
  {
    path: 'product-admin-form/:productId',
    loadComponent: () => import('./product-admin-form/product-admin-form.page').then(m => m.ProductAdminFormPage),
  },
  {
    path: 'equipment-admin-form/:equipmentId',
    loadComponent: () => import('./equipment-admin-form/equipment-admin-form.page').then(m => m.EquipmentAdminFormPage),
  },
  {
    path: 'transference-admin-form/:transferenceId',
    loadComponent: () => import('./transference-admin-form/transference-admin-form.page').then(m => m.TransferenceAdminFormPage),
  },
  {
    path: 'pools-admin/:localId',
    loadComponent: () => import('./pools-admin/pools-admin.page').then(m => m.PoolsAdminPage),
  },
  {
    path: 'pool-admin-form/:poolId',
    loadComponent: () => import('./pool-admin-form/pool-admin-form.page').then(m => m.PoolAdminFormPage),
  },
  {
    path: 'local-stock-admin/:localId',
    loadComponent: () => import('./local-stock-admin/local-stock-admin.page').then(m => m.LocalStockAdminPage),
  },
  {
    path: 'product-admin/:productId',
    loadComponent: () => import('./product-admin/product-admin.page').then(m => m.ProductAdminPage),
  },
  {
    path: 'tasks-admin',
    loadComponent: () => import('./tasks-admin/tasks-admin.page').then(m => m.TasksAdminPage),
  },
  {
    path: 'commitments-admin',
    loadComponent: () => import('./commitments-admin/commitments-admin.page').then(m => m.CommitmentsAdminPage),
  },
  {
    path: 'commitments-schedule',
    loadComponent: () => import('./commitments-schedule/commitments-schedule.page').then(m => m.CommitmentsSchedulePage),
  },
  {
    path: 'commitment-admin-form',
    loadComponent: () => import('./commitment-admin-form/commitment-admin-form.page').then(m => m.CommitmentAdminFormPage),
  },
  {
    path: 'local-equipments-admin',
    loadComponent: () => import('./local-equipments-admin/local-equipments-admin.page').then(m => m.LocalEquipmentsAdminPage),
  },
  {
    path: 'local-equipment-admin',
    loadComponent: () => import('./local-equipment-admin/local-equipment-admin.page').then(m => m.LocalEquipmentAdminPage),
  },
  {
    path: 'transference-create',
    loadComponent: () => import('./transference-create/transference-create.page').then(m => m.TransferenceCreatePage),
  },
  {
    path: 'notification/:notificationId',
    loadComponent: () => import('./notification/notification.page').then(m => m.NotificationPage),
  },
  {
    path: 'analyze-admin/:analyzeId',
    loadComponent: () => import('./analyze-admin/analyze-admin.page').then(m => m.AnalyzeAdminPage),
  },
  {
    path: 'leads',
    loadComponent: () => import('./leads/leads.page').then(m => m.LeadsPage),
  },
  {
    path: 'lead-order/:leadId',
    loadComponent: () => import('./lead-order/lead-order.page').then(m => m.LeadOrderPage),
  },
  {
    path: 'lead/:leadId',
    loadComponent: () => import('./lead/lead.page').then(m => m.LeadPage),
  },
  {
    path: 'lead-orders',
    loadComponent: () => import('./lead-orders/lead-orders.page').then(m => m.LeadOrdersPage),
  },
  {
    path: 'my-leads',
    loadComponent: () => import('./my-leads/my-leads.page').then(m => m.MyLeadsPage),
  },
  {
    path: 'credit-purchase',
    loadComponent: () => import('./credit-purchase/credit-purchase.page').then(m => m.CreditPurchasePage),
  },
  {
    path: 'payment',
    loadComponent: () => import('./payment/payment.page').then(m => m.PaymentPage),
  },
  {
    path: 'clients',
    loadComponent: () => import('./clients/clients.page').then(m => m.ClientsPage),
  },
  {
    path: 'client/:clientId',
    loadComponent: () => import('./client/client.page').then(m => m.ClientPage),
  },
  {
    path: 'report-link',
    loadComponent: () => import('@shared/pages/report-link/report-link.page').then(m => m.ReportLinkPage),
  },
  {
    path: 'preferences',
    loadComponent: () => import('@shared/pages/preferences/preferences.page').then(m => m.PreferencesPage),
  },
  {
    path: 'signup/:clientId',
    loadComponent: () => import('./signup-standard/signup-standard.page').then(m => m.SignupStandardPage),
  },
  {
    path: 'change-password/:passwordResetId',
    loadComponent: () => import('./change-password/change-password.page').then(m => m.ChangePasswordPage),
  },
  {
    path: 'lead-admin-form/:leadId',
    loadComponent: () => import('./lead-admin-form/lead-admin-form.page').then(m => m.LeadAdminFormPage),
  },
  {
    path: 'qr-code',
    loadComponent: () => import('./qr-code/qr-code.page').then(m => m.QrCodePage),
  },
  {
    path: 'qr-code-scanner',
    loadComponent: () => import('./qr-code-scanner/qr-code-scanner.page').then(m => m.QrCodeScannerPage),
  },
  {
    path: 'signup-pro/:code',
    loadComponent: () => import('./signup-pro/signup-pro.page').then(m => m.SignupProPage),
  },
  {
    path: 'signup-link-form',
    loadComponent: () => import('./signup-link-form/signup-link-form.page').then(m => m.SignupLinkFormPage),
  },
  {
    path: 'client-admin-form/:clientId',
    loadComponent: () => import('./client-admin-form/client-admin-form.page').then(m => m.ClientAdminFormPage),
  },
  {
    path: 'leads-notifications',
    loadComponent: () => import('./leads-notifications/leads-notifications.page').then(m => m.LeadsNotificationsPage),
  },
  {
    path: 'delete-account-modal',
    loadComponent: () => import('@shared/pages/delete-account-modal/delete-account-modal.page').then(m => m.DeleteAccountModalPage),
  },
];
